module.exports = __webpack_public_path__ + "img/State=19.160d2ae6.svg";